// extracted by mini-css-extract-plugin
export var modal = "_52-0";